import { render, staticRenderFns } from "./AtlasChatWidgetLoader.vue?vue&type=template&id=1cdcd614&scoped=true"
import script from "./AtlasChatWidgetLoader.vue?vue&type=script&lang=js"
export * from "./AtlasChatWidgetLoader.vue?vue&type=script&lang=js"
import style0 from "./AtlasChatWidgetLoader.vue?vue&type=style&index=0&id=1cdcd614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdcd614",
  null
  
)

export default component.exports